import { ComponentsConfig, ConfigState, EmpathyXConfig } from '../../../models';
import { CONFIG_GETTERS_KEYS } from '../config.const';
import { ConfigGetter } from '../config.interfaces';

export class ComponentsGetter implements ConfigGetter {
  getters = {
    [CONFIG_GETTERS_KEYS.components]: (configState: ConfigState, getters: any): ComponentsConfig => {
      const config: EmpathyXConfig = getters[CONFIG_GETTERS_KEYS.config];
      return {
        addToCartOnProductPage: config.tracking.addToCart.components.addToCartOnProductPage,
        close: config.close.components,
        empathize: config.empathize.components,
        emptySearch: config.emptySearch.components.emptySearch,
        fallbackFilters: config.fallbackFilters.components,
        history: config.history.components,
        identifierSuggestions: config.identifierSuggestions.components,
        nextQueriesSuggestions: config.nextQueriesSuggestions.components,
        nextQueries: config.nextQueries.components,
        noResults: config.noResults.components.noResults,
        open: config.open.components.open,
        partials: config.partialResults.components,
        popularSearches: config.popularSearches.components,
        recommendations: config.recommendations.components,
        redirectionsSuggestions: config.redirectionsSuggestions.components,
        relatedTags: config.relatedTags.components,
        resultsGrid: config.resultsGrid.components,
        resultsNumber: config.resultsNumber.components.resultsNumber,
        resultsSuggestions: config.resultsSuggestions.components,
        scrollToTop: config.scrollToTop.components,
        sort: config.sort.components,
        spellcheck: config.spellcheck.components.spellcheck,
        searchBox: config.searchBox.components,
        termSuggestions: config.termSuggestions.components,
        windowEventBinder: config.windowEventBinder.components.windowEventBinder
      };
    }
  };
}
